import { useAtom } from 'jotai';
import { TenantSelector as SharedTenantSelector } from '../common/selectors/TenantSelector';
import { changeCurrentTenant } from '../services/tenantService';
import { profileDataAtom, type IProfileData } from '../atoms/authAtoms';

export interface ITenantSelectorProps {
  isOpen: boolean;
  hideTenantSelector: () => void;
}

const TenantSelector = ({
  isOpen,
  hideTenantSelector,
}: ITenantSelectorProps) => {
  const [profileData, setProfileData] = useAtom(profileDataAtom);

  return (
    <SharedTenantSelector
      isOpen={isOpen}
      onDismiss={hideTenantSelector}
      selectedTenantId={profileData.currentTenant}
      headerText={profileData.userPrincipalName}
      onTenantSelected={(tenant) => {
        const abortController = new AbortController();
        changeCurrentTenant(
          abortController,
          profileData.userPrincipalName,
          tenant.id
        ).then(() => {
          hideTenantSelector();
          setProfileData((prev: IProfileData) => ({
            ...prev,
            currentTenant: tenant.id,
          }));
        });
      }}
    />
  );
};

export default TenantSelector;
